import modalClasses from '@/styles/mantine/Modal.module.css'
import { Modal as MantineModal, rem, ScrollArea } from '@mantine/core'

export const Modal = MantineModal.extend({
	defaultProps: {
		radius: rem(10),
		centered: true,
		scrollAreaComponent: ScrollArea.Autosize,
		classNames: {
			root: modalClasses.root,
			header: modalClasses.header,
			title: modalClasses.title,
			close: modalClasses.close,
		},
	},
})
